import {pushEdapEvent} from '../../utils/edap';

export function pushNoImageDataEvent(lbsId) {
    pushEdapEvent('generic.event', {
        actionlocation: 'destinations-component',
        eventaction: 'fallback',
        eventcategory: 'image-source',
        eventrefinements: 'FALLBACK_IMAGE_MISSING',
        lbsId,
    });
}
